import React from 'react';
import { getPickleBallRating } from '../../../../utils';
import { ratingTypes } from '../../../../utils/constants';

const PickleBallRating = props => {
    const {
        player,
        addSuffix = false,
        ratingType,
        'data-testid': dataTestId,
    } = props;

    const pkbRating = getPickleBallRating(player, ratingType);
    return (
        <>
            <div className="values" data-testid={dataTestId && `${dataTestId}.values`}>
                {!!pkbRating.value && (
                    <div
                        className={`value`}
                        title={pkbRating.title}
                        data-testid={dataTestId && `${dataTestId}.value`}
                    >
                        {`${pkbRating.value}${addSuffix ? ` (${ratingTypes.pickleball})` : ''}`}
                    </div>
                )}
            </div>
        </>
    );
};

PickleBallRating.defaultProps = {
    'data-testid': null,
};

export default PickleBallRating;
